import React from 'react';
import get from 'lodash/get';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { LINE_ITEM_INITIAL_PAYMENT, propTypes } from '../../util/types';
import { formatMoney, formatMoneyWithExtra } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  txGetPromoLineItem,
  txIsCanceled,
  txIsCanceledByCustomer,
  txIsDeclined,
  txIsDelivered,
} from '../../util/transaction';

import css from './BookingBreakdownNew.css';

const { Money } = sdkTypes;

const addSecurityDeposit = (inputString) => {

  // Step 1: Remove the "$" sign and extract the numeric value
  const numericValue = parseFloat(inputString.replace("$", ""));

  // Step 2: Add 250 to the numeric value
  const resultValue = numericValue + 250;

  // Step 3: Convert the result back to a string and append the "$" sign
  const resultString = "$" + resultValue; // Using toFixed(2) to keep two decimal places

 return resultString
}

const LineItemTotalPriceNew = props => {
  const { transaction, isProvider, intl, currentUser, openInvoicesTotal, isTripExtension } = props;

  if (!transaction) {
    return (
      <div className={css.lineItemTotal}>
        <div className={css.totalPrice}>$-</div>
      </div>
    );
  }

  let providerTotalMessageId = 'BookingBreakdown.providerTotalDefault';
  if (txIsDelivered(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalDelivered';
  } else if (txIsDeclined(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalDeclined';
  } else if (txIsCanceled(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalCanceled';
  }

  const isLongTermRental = get(transaction, 'attributes.protectedData.isLongTermRental');
  const totalLabel = isProvider ? (
    <FormattedMessage id={providerTotalMessageId} />
  ) : isLongTermRental ? (
    <FormattedMessage id="BookingBreakdownLongTerm.total" />
  ) : (
    <FormattedMessage id="BookingBreakdown.total" />
  );

  const promoItem = txGetPromoLineItem(transaction);

  const promoAmount = promoItem && !txIsCanceled(transaction) ? promoItem.lineTotal.amount : 0;
  const processingFees = get(
    transaction,
    'attributes.protectedData.commissionObj.commission.processingFees',
    0
  );

  const initialPaymentLineItem = transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_INITIAL_PAYMENT
  );

  console.log("Price processing", processingFees)
  const payoutTotal = transaction.attributes.payoutTotal;
  const totalPrice = isProvider
    ? payoutTotal
    : txIsCanceledByCustomer(transaction)
    ? new Money(processingFees, payoutTotal.currency)
    : transaction.attributes.payinTotal;

  const newTotal = initialPaymentLineItem && !isTripExtension
    ? new Money(totalPrice.amount - Math.abs(initialPaymentLineItem.lineTotal.amount || 0), totalPrice.currency)
    : totalPrice;

  const finalTotalPrice = isProvider
    ? new Money(totalPrice.amount - (promoAmount || 0), totalPrice.currency)
    : newTotal;

  // const currentDepositStatus = get(currentUser, 'attributes.profile.metadata.depositChargeStatus', '');

  const shouldChargeDeposit = get(transaction, 'attributes.protectedData.shouldChargeDeposit', false);


    let finalUpdatedPrice = finalTotalPrice;
    console.log("Heelo", finalTotalPrice, totalPrice)

  // Add open invoices total if it exists
  if (openInvoicesTotal && openInvoicesTotal.amount) {
    finalUpdatedPrice = new Money(
      finalUpdatedPrice.amount + openInvoicesTotal.amount,
      finalUpdatedPrice.currency
    );
  }

  let formattedTotalPrice = formatMoney(intl, finalUpdatedPrice, 2);
  if(shouldChargeDeposit) {
    if(isProvider) {

    }
    else {
      formattedTotalPrice = formatMoneyWithExtra(intl, finalUpdatedPrice, 1);
      // console.log("Deposit", finalUpdatedPrice.amount)
      // newFormattedPrice = addSecurityDeposit(newFormattedPrice)
    }
  }

  console.log("gina on", formattedTotalPrice)

  const hostCredits =
    !isProvider || !currentUser || !currentUser.attributes
      ? 0
      : currentUser.attributes.credits
      ? currentUser.attributes.credits
      : 0;

  const hostCreditMoney =
    !hostCredits || hostCredits < 20
      ? null
      : formatMoney(intl, new Money(2000, totalPrice.currency), 2);

    let newFormattedPrice = formattedTotalPrice


  return (
    <div className={css.lineItemTotal}>
      <div className={css.totalPrice}>{newFormattedPrice}</div>
    </div>
  );
};

LineItemTotalPriceNew.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
  openInvoicesTotal: propTypes.money,
};

export default LineItemTotalPriceNew;
